import Vue from 'vue'
import Router from 'vue-router'
import {auth, db} from '@/store/firebase'
import {store} from '@/store'

Vue.use(Router)

function route (path, file, name, requiresAuth, children) {
  return {
    exact: true,
    props: path.indexOf(':') > -1,
    path,
    name,
    children,
    meta: { requiresAuth },
    component: require(`./pages/${file}.vue`).default
  }
}

const router = new Router({
  routes: [
    route('/login', 'Login', 'Login', false),
    route('/reports/:patId/:serviceDate', 'Report', 'Laudo', true),
    route('/patient-portal2/:id', 'PatientPortal', 'PatientPortal', true),
    route('/patient-portal/:id', 'PatientPortal2', 'PatientPortal2', true),
    route('/', 'Main', null, true, [
      route('/', 'Home', 'Home', true),
      route('/studies', 'Studies', 'Lista de Exames', true),
      route('/studies/:id', 'Study', 'Exame', true),
      route('/viewer/:id', 'Viewer', 'Viewer', true),
      route('/studies/:company/:patId/:serviceDate', 'Study', 'Exames do Paciente', true),
      route('/worklist', 'Worklist', 'Worklist', true),
      route('/devices', 'Devices', 'Dispositivos', true),
      route('/patients', 'Patients', 'Pacientes', true),
      route('/users', 'Users', 'Users', true),
      route('/companies', 'Companies', 'Companies', true),
      route('/profile', 'ultra-fetal/Profile', 'Perfil`', true),
      route('/general-report/:id', 'GeneralReport', 'GeneralReport', true),
      route('/upload-files', 'UploadFiles', 'Upload Files', true),
      route('/medical-record/:recordId', 'medical-record/MedicalRecord', 'Prontuario Eletronico', true)
    ]),
    route('/ultra-fetal/patient/:patientId', 'ultra-fetal/Main', null, true, [
      route('/', 'ultra-fetal/Gestations', 'Ultra Fetal Gestations', true),
      route('gestation-interaction/:gestationInteractionId', 'ultra-fetal/Home', 'Ultra Fetal Gestation Interaction', true, [
        route('form/:formId', 'ultra-fetal/Form', 'Ultra Fetal Form', true),
        route('medias', 'ultra-fetal/Medias', 'Ultra Fetal Medias', true),
        route('conclusion', 'ultra-fetal/Conclusion', 'Ultra Fetal Form Conclusion', true),
        route('summary', 'ultra-fetal/summary/index', 'Ultra Fetal Form Summary', true),
        route('observations', 'ultra-fetal/Observations', 'Ultra Fetal Form Observations', true)
      ])
    ])
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.fullPath.startsWith('/patient-portal/')) {
    next()
  } else {
    const { email, pass } = to.query
    if (email && pass) {
      await auth.signInWithEmailAndPassword(email, pass)
    }
    auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        window.errorHandler.setUser(`${currentUser.uid} (${currentUser.email})`)
        db.collection('users').doc(currentUser.uid).get().then(doc => {
          const configs = doc.data()
          const user = {
            uid: currentUser.uid,
            displayName: currentUser.displayName,
            isAnonymous: currentUser.isAnonymous,
            phoneNumber: currentUser.phoneNumber,
            photoURL: currentUser.photoURL,
            email: currentUser.email,
            ...configs
          }
          store.dispatch('setUser', user)
          next()
        })
      } else if (!to.meta.requiresAuth) {
        next()
      } else {
        next('/login')
      }
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js